// pages/GuildHeader.js
import React, { useState } from "react";
import { guildDataService } from "./GuildDataService";
import GuildLogo from "./GuildLogo";

function GuildHeader({ guild, members, currentUser, onUpdateGuild }) {
  const [editIntro, setEditIntro] = useState(false);
  const [editedIntro, setEditedIntro] = useState(guild.intro || "");
  const [msg, setMsg] = useState("");
  const [editHashtags, setEditHashtags] = useState(false);
  const [editedHashtags, setEditedHashtags] = useState(guild.hashtags || []);
  const [hashtagInput, setHashtagInput] = useState("");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  
  // 추천 해시태그 목록
  const recommendedHashtags = [
    "탁구", "친목", "실력향상", "연습", "대회", "초보", "고수", "매칭", "팀워크", "운동"
  ];

  const handleIntroEdit = async () => {
    if (!editedIntro.trim()) {
      setMsg("한줄 소개를 입력하세요.");
      return;
    }
    
    try {
      await guildDataService.updateGuild(guild.id, { intro: editedIntro });
      setMsg("한줄 소개가 수정되었습니다.");
      setEditIntro(false);
      onUpdateGuild({ ...guild, intro: editedIntro });
      
      setTimeout(() => setMsg(""), 3000);
    } catch (error) {
      console.error("소개 수정 실패:", error);
      setMsg("소개 수정에 실패했습니다.");
    }
  };

  const handleHashtagSave = async () => {
    try {
      await guildDataService.updateGuild(guild.id, { hashtags: editedHashtags });
      setMsg("해시태그가 수정되었습니다.");
      setEditHashtags(false);
      onUpdateGuild({ ...guild, hashtags: editedHashtags });
      setTimeout(() => setMsg(""), 3000);
    } catch (error) {
      setMsg("해시태그 수정에 실패했습니다.");
    }
  };

  const addHashtag = () => {
    const tag = hashtagInput.replace('#','').trim();
    if (tag && !editedHashtags.includes(tag) && editedHashtags.length < 10) {
      setEditedHashtags([...editedHashtags, tag]);
      setHashtagInput("");
    }
  };
  const removeHashtag = (tag) => {
    setEditedHashtags(editedHashtags.filter(t => t !== tag));
  };

  const handleGuildDelete = async () => {
    try {
      await guildDataService.deleteGuild(guild.id);
      setMsg("길드가 삭제되었습니다.");
      setShowDeleteConfirm(false);
      // 홈페이지로 리다이렉트
      window.location.href = '/';
    } catch (error) {
      console.error("길드 삭제 실패:", error);
      setMsg("길드 삭제에 실패했습니다.");
    }
  };

  const isLeader = guild.leaderId === currentUser.id;

  return (
    <div style={{
      borderRadius: 24,
      padding: 32,
      marginBottom: 24,
      color: '#000000',
      background: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      gap: 24,
      boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
      minHeight: 200
    }}>
      {/* 상단: 로고 + 길드명 + 스포츠 + 멤버 + 포인트 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
        <GuildLogo 
          logoUrl={guild.logoUrl} 
          guildName={guild.name} 
          size={80} 
          showBorder={true} 
          borderColor="rgba(102,126,234,0.15)"
        />
        <div style={{ display: 'flex', alignItems: 'center', gap: 20, flexWrap: 'wrap' }}>
          <h1 style={{ fontSize: 36, fontWeight: 900, margin: 0, color: '#000000', letterSpacing: -0.5 }}>{guild.name}</h1>
          <span style={{ fontSize: 18, fontWeight: 700, color: '#6366f1', background: '#eef2ff', borderRadius: 8, padding: '6px 12px', display: 'inline-flex', alignItems: 'center' }}>{guild.sport && `🎯 ${guild.sport}`}</span>
          <span style={{ fontSize: 18, color: '#374151', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4 }}>👥 {members.length}명</span>
          <span style={{ fontSize: 18, color: '#059669', fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4 }}>🏆 {guild.point || 0}점</span>
        </div>
      </div>
      
      {/* 중간: 길드 소개 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span style={{ fontSize: 20, color: '#000000', fontWeight: 600, opacity: 0.9 }}>
          {guild.intro || '길드 소개가 없습니다'}
        </span>
        {isLeader && (
          <button onClick={() => setEditIntro(true)} style={{ background: '#f3f4f6', color: '#6366f1', border: 'none', borderRadius: 6, padding: '4px 8px', fontWeight: 700, fontSize: 16, cursor: 'pointer' }}>✏️</button>
        )}
        <span style={{ fontSize: 16, color: '#6b7280', fontWeight: 600, marginLeft: 8 }}>🏆 길드 랭킹 #측정중</span>
      </div>
      
      {/* 하단: 해시태그 */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', minHeight: 32 }}>
        {(guild.hashtags && guild.hashtags.length > 0) ? (
          guild.hashtags.map((tag, idx) => (
            <span
              key={idx}
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: '#ffffff',
                borderRadius: 16,
                padding: '8px 18px',
                fontSize: 16,
                fontWeight: 700,
                letterSpacing: 0.3,
                boxShadow: '0 2px 8px #667eea33',
                display: 'inline-block',
                transition: 'transform 0.15s',
                cursor: 'pointer',
                border: 'none',
                margin: 0,
              }}
              onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
              onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              #{tag}
            </span>
          ))
        ) : (
          isLeader ? (
            <button
              onClick={() => setEditHashtags(true)}
              style={{
                background: 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)',
                color: '#3730a3',
                border: 'none',
                borderRadius: 16,
                padding: '8px 18px',
                fontSize: 16,
                fontWeight: 700,
                cursor: 'pointer',
                boxShadow: '0 2px 8px #c7d2fe33',
                transition: 'background 0.2s, color 0.2s',
              }}
              onMouseOver={e => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #a5b4fc 0%, #818cf8 100%)';
                e.currentTarget.style.color = '#ffffff';
              }}
              onMouseOut={e => {
                e.currentTarget.style.background = 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%)';
                e.currentTarget.style.color = '#3730a3';
              }}
            >
              + 해시태그 추가
            </button>
          ) : (
            <span style={{ color: '#9ca3af', fontSize: 16, fontWeight: 600 }}>해시태그 없음</span>
          )
        )}
          </div>
          
      {/* 맨 하단: 통계 카드들 가로 배치 */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap', marginTop: 8 }}>
        <div style={{ background: '#f8fafc', borderRadius: 12, padding: '18px 24px', minWidth: 80, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 28 }}>👥</div>
          <div style={{ fontWeight: 800, fontSize: 20, color: '#000000' }}>{members.length}</div>
          <div style={{ fontSize: 14, color: '#374151', fontWeight: 600 }}>멤버</div>
        </div>
        <div style={{ background: '#f8fafc', borderRadius: 12, padding: '18px 24px', minWidth: 80, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 28 }}>🏆</div>
          <div style={{ fontWeight: 800, fontSize: 20, color: '#000000' }}>{guild.point || 0}</div>
          <div style={{ fontSize: 14, color: '#374151', fontWeight: 600 }}>포인트</div>
        </div>
        <div style={{ background: '#f8fafc', borderRadius: 12, padding: '18px 24px', minWidth: 80, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 28 }}>⚔️</div>
          <div style={{ fontWeight: 800, fontSize: 20, color: '#000000' }}>0</div>
          <div style={{ fontSize: 14, color: '#374151', fontWeight: 600 }}>길드전</div>
        </div>
        <div style={{ background: '#f8fafc', borderRadius: 12, padding: '18px 24px', minWidth: 80, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, border: '1px solid #e5e7eb' }}>
          <div style={{ fontSize: 28 }}>📝</div>
          <div style={{ fontWeight: 800, fontSize: 20, color: '#000000' }}>0</div>
          <div style={{ fontSize: 14, color: '#374151', fontWeight: 600 }}>게시글</div>
        </div>
        {/* 길드 삭제 버튼 (길드장만) */}
        {isLeader && (
          <button
            onClick={() => setShowDeleteConfirm(true)}
            style={{
              background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
              color: '#ffffff',
              border: 'none',
              borderRadius: 12,
              padding: '18px 24px',
              minWidth: 80,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 6,
              cursor: 'pointer',
              fontWeight: 700,
              fontSize: 14,
              boxShadow: '0 2px 8px #ef444433',
              transition: 'transform 0.15s'
            }}
            onMouseOver={e => e.currentTarget.style.transform = 'scale(1.02)'}
            onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
          >
            <div style={{ fontSize: 28 }}>🗑️</div>
            <div style={{ fontWeight: 800, fontSize: 16, color: '#ffffff' }}>삭제</div>
            <div style={{ fontSize: 12, color: '#fecaca', fontWeight: 600 }}>길드</div>
          </button>
        )}
              </div>
      
      {/* 길드 삭제 확인 모달 */}
      {showDeleteConfirm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#ffffff',
            borderRadius: 16,
            padding: 32,
            maxWidth: 400,
            width: '90%',
            textAlign: 'center',
            boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
          }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
            <h3 style={{ fontSize: 24, fontWeight: 900, color: '#000000', margin: '0 0 16px 0' }}>
              길드 삭제
            </h3>
            <p style={{ fontSize: 16, color: '#374151', lineHeight: 1.6, margin: '0 0 24px 0' }}>
              <strong>"{guild.name}"</strong> 길드를 정말 삭제하시겠습니까?<br />
              이 작업은 되돌릴 수 없습니다.
            </p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <button
                onClick={() => setShowDeleteConfirm(false)}
                style={{
                  background: '#f3f4f6',
                  color: '#374151',
                  border: 'none',
                  borderRadius: 8,
                  padding: '12px 24px',
                  fontWeight: 700,
                  fontSize: 16,
                  cursor: 'pointer'
                }}
              >
                취소
              </button>
              <button
                onClick={handleGuildDelete}
                style={{
                  background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: 8,
                  padding: '12px 24px',
                  fontWeight: 700,
                  fontSize: 16,
                  cursor: 'pointer'
                }}
              >
                삭제
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* 해시태그/소개 수정 등 기존 UI 유지 */}
      {msg && (
        <div style={{ position: 'absolute', top: 16, left: 0, right: 0, textAlign: 'center', zIndex: 10 }}>
          <div style={{ display: 'inline-block', background: '#6366f1', color: '#ffffff', borderRadius: 8, padding: '8px 24px', fontWeight: 700, fontSize: 15, boxShadow: '0 2px 8px #6366f122' }}>{msg}</div>
        </div>
      )}
      {/* 해시태그/소개 수정 UI는 기존대로 아래에 노출 */}
              {editIntro ? (
                <div style={styles.editIntroContainer}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                  <input
              type="text"
                    value={editedIntro}
                    onChange={(e) => setEditedIntro(e.target.value)}
                    placeholder="길드 소개를 입력하세요"
              style={{
                flex: 1,
                padding: '12px 16px',
                borderRadius: 8,
                border: '2px solid #e5e7eb',
                fontSize: 16,
                color: '#000000',
                background: '#ffffff',
                outline: 'none'
              }}
              onFocus={(e) => e.target.style.borderColor = '#6366f1'}
              onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  />
            <button
              onClick={handleIntroEdit}
              style={{
                background: '#6366f1',
                color: '#ffffff',
                border: 'none',
                borderRadius: 8,
                padding: '12px 20px',
                fontWeight: 700,
                fontSize: 16,
                cursor: 'pointer'
              }}
            >
                    저장
                  </button>
            <button
              onClick={() => {
                setEditIntro(false);
                setEditedIntro(guild.intro || '');
              }}
              style={{
                background: '#f3f4f6',
                color: '#6b7280',
                border: 'none',
                borderRadius: 8,
                padding: '12px 20px',
                fontWeight: 700,
                fontSize: 16,
                cursor: 'pointer'
              }}
            >
                    취소
                  </button>
                </div>
        </div>
      ) : null}
      <div style={{ marginTop: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {editHashtags ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12, width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                <input
                  type="text"
                  value={hashtagInput}
                  onChange={(e) => setHashtagInput(e.target.value)}
                  placeholder="해시태그 입력 (예: 탁구, 친목, 실력향상)"
                  style={{
                    flex: 1,
                    minWidth: 200,
                    padding: '12px 16px',
                    borderRadius: 8,
                    border: '2px solid #e5e7eb',
                    fontSize: 16,
                    color: '#000000',
                    background: '#ffffff',
                    outline: 'none'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#6366f1'}
                  onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      addHashtag();
                    }
                  }}
                />
                <button
                  onClick={addHashtag}
                  style={{
                    background: '#6366f1',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: 8,
                    padding: '12px 20px',
                    fontWeight: 700,
                    fontSize: 16,
                    cursor: 'pointer'
                  }}
                >
                  추가
                </button>
              </div>
              {/* 추천 해시태그 */}
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                {recommendedHashtags.map((tag, idx) => (
                    <button 
                    key={idx}
                    onClick={() => {
                      if (!editedHashtags.includes(tag)) {
                        setEditedHashtags([...editedHashtags, tag]);
                      }
                    }}
                    disabled={editedHashtags.includes(tag)}
                    style={{
                      background: editedHashtags.includes(tag) ? '#f3f4f6' : '#e0e7ff',
                      color: editedHashtags.includes(tag) ? '#9ca3af' : '#3730a3',
                      border: 'none',
                      borderRadius: 16,
                      padding: '6px 12px',
                      fontSize: 14,
                      fontWeight: 600,
                      cursor: editedHashtags.includes(tag) ? 'not-allowed' : 'pointer',
                      opacity: editedHashtags.includes(tag) ? 0.5 : 1
                    }}
                  >
                    #{tag}
                  </button>
                ))}
              </div>
              {/* 현재 해시태그 미리보기 */}
              {editedHashtags.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                  <span style={{ fontSize: 14, fontWeight: 600, color: '#374151' }}>현재 해시태그:</span>
                  {editedHashtags.map((tag, idx) => (
                    <span
                      key={idx}
                      style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: '#ffffff',
                        borderRadius: 16,
                        padding: '6px 12px',
                        fontSize: 14,
                        fontWeight: 700,
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6
                      }}
                    >
                      #{tag}
                      <button
                        onClick={() => removeHashtag(tag)}
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#ffffff',
                          cursor: 'pointer',
                          fontSize: 12,
                          padding: 0,
                          marginLeft: 4
                        }}
                      >
                        ×
                    </button>
                    </span>
                  ))}
                </div>
              )}
              <div style={{ display: 'flex', gap: 12 }}>
                <button
                  onClick={handleHashtagSave}
                  style={{
                    background: '#6366f1',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: 8,
                    padding: '12px 20px',
                    fontWeight: 700,
                    fontSize: 16,
                    cursor: 'pointer'
                  }}
                >
                  저장
                </button>
                <button
                  onClick={() => {
                    setEditHashtags(false);
                    setEditedHashtags(guild.hashtags || []);
                    setHashtagInput('');
                  }}
                  style={{
                    background: '#f3f4f6',
                    color: '#6b7280',
                    border: 'none',
                    borderRadius: 8,
                    padding: '12px 20px',
                    fontWeight: 700,
                    fontSize: 16,
                    cursor: 'pointer'
                  }}
                >
                  취소
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

const styles = {
  guildHeader: {
    borderRadius: 24,
    padding: 32,
    marginBottom: 24,
    color: "#fff"
  },
  guildHeaderContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 32,
    flexWrap: "wrap"
  },
  guildInfoSection: {
    display: "flex",
    alignItems: "center",
    gap: 24,
    flex: 1
  },
  guildAvatar: {
    position: "relative",
    flexShrink: 0
  },
  guildCoverImage: {
    width: 100,
    height: 100,
    borderRadius: "50%",
    objectFit: "cover",
    border: "4px solid rgba(255,255,255,0.3)"
  },
  guildDefaultAvatar: {
    width: 100,
    height: 100,
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,0.2)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 40,
    border: "4px solid rgba(255,255,255,0.3)"
  },
  guildOnlineIndicator: {
    position: "absolute",
    bottom: 8,
    right: 8,
    width: 16,
    height: 16,
    backgroundColor: "#4caf50",
    borderRadius: "50%",
    border: "3px solid #fff"
  },
  guildDetails: {
    flex: 1
  },
  guildNameSection: {
    marginBottom: 12
  },
  guildName: {
    fontSize: 36,
    fontWeight: 900,
    margin: 0,
    textShadow: "0 2px 8px rgba(0,0,0,0.3)",
    display: "flex",
    alignItems: "center",
    gap: 16,
    flexWrap: "wrap"
  },
  guildSportBadge: {
    background: "rgba(255,215,0,0.2)",
    color: "#FFD700",
    padding: "8px 16px",
    borderRadius: 20,
    fontSize: 16,
    fontWeight: 700,
    border: "2px solid rgba(255,215,0,0.4)"
  },
  guildRanking: {
    fontSize: 16,
    opacity: 0.9,
    fontWeight: 600,
    marginTop: 8
  },
  guildIntroSection: {
    marginTop: 8
  },
  editIntroContainer: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap"
  },
  editIntroInput: {
    background: "rgba(255,255,255,0.2)",
    border: "2px solid rgba(255,255,255,0.3)",
    borderRadius: 12,
    padding: "12px 16px",
    color: "#fff",
    fontSize: 16,
    fontWeight: 500,
    flex: 1,
    minWidth: 200
  },
  saveButton: {
    background: "#4caf50",
    color: "#fff",
    border: "none",
    borderRadius: 10,
    padding: "12px 20px",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    transition: "all 0.2s"
  },
  cancelButton: {
    background: "rgba(255,255,255,0.2)",
    color: "#fff",
    border: "2px solid rgba(255,255,255,0.3)",
    borderRadius: 10,
    padding: "12px 20px",
    fontSize: 14,
    fontWeight: 700,
    cursor: "pointer",
    transition: "all 0.2s"
  },
  guildIntroDisplay: {
    display: "flex",
    alignItems: "center",
    gap: 12
  },
  guildIntro: {
    fontSize: 16,
    margin: 0,
    opacity: 0.9,
    fontStyle: "italic",
    lineHeight: 1.5
  },
  editButton: {
    background: "rgba(255,255,255,0.2)",
    border: "2px solid rgba(255,255,255,0.3)",
    borderRadius: 8,
    padding: "8px 12px",
    fontSize: 14,
    cursor: "pointer",
    color: "#fff",
    transition: "all 0.2s"
  },
  guildStatsSection: {
    display: "flex",
    gap: 16,
    flexWrap: "wrap"
  },
  statCard: {
    background: "rgba(255,255,255,0.15)",
    borderRadius: 16,
    padding: 20,
    textAlign: "center",
    minWidth: 100,
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255,255,255,0.2)"
  },
  statIcon: {
    fontSize: 24,
    marginBottom: 8
  },
  statValue: {
    fontSize: 24,
    fontWeight: 900,
    color: "#fff",
    lineHeight: 1
  },
  statLabel: {
    fontSize: 12,
    opacity: 0.8,
    marginTop: 4,
    fontWeight: 600
  },
  messageContainer: {
    marginTop: 20
  },
  message: {
    background: "#4caf50",
    color: "#fff",
    padding: "16px 24px",
    borderRadius: 12,
    fontSize: 16,
    fontWeight: 600,
    boxShadow: "0 4px 12px rgba(76,175,80,0.3)"
  }
};

export default GuildHeader;